import { render } from "./ArticlesView.vue?vue&type=template&id=ef9ee7f0&scoped=true"
import script from "./ArticlesView.vue?vue&type=script&lang=js"
export * from "./ArticlesView.vue?vue&type=script&lang=js"

import "./ArticlesView.vue?vue&type=style&index=0&id=ef9ee7f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9ee7f0"]])

export default __exports__